/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest
 */
export interface RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest {
    /**
     * 
     * @type {string}
     * @memberof RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest
     */
    options?: string;
}

/**
 * Check if a given object implements the RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest interface.
 */
export function instanceOfRoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest(value: object): value is RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest {
    return true;
}

export function RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestFromJSON(json: any): RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest {
    return RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestFromJSONTyped(json, false);
}

export function RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'options': json['options'] == null ? undefined : json['options'],
    };
}

export function RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON(json: any): RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest {
    return RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSONTyped(json, false);
}

export function RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSONTyped(value?: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'options': value['options'],
    };
}

